<template>
  <div class="main">
    <div class="title">采集地点</div>

    <div class="content">
      
        <div class="sj">您可以按照以下信息， 携带本人身份证件，直接前往登记验血报名，具体信息如下：</div>
        <div class="sj mt30">第一采集室：成都北路献血屋；</div>
        <div class="sj">时间：全年开放，每天9：00～16：00；</div>
        <div class="sj">地点：成都北路408号献血屋2楼(南京西路口，近成都北路高架，南证大厦马路斜对面)；</div>
        <div class="sj">交通：公交20、37、36、112、933、地铁1、2号线人民广场站下9、10、11号出口；</div>
        <div class="sj">电话：63592144；</div>
        <div class="sj"></div>
        <div class="sj mt30">第二采集室：上海市血液中心；</div>
        <div class="sj">时间：全年开放，每天9：00～16：00 ；</div>
        <div class="sj">地点：虹桥路1191号1号楼204室(近伊犁路口)</div>
        <div class="sj">交通：公交48、72、506、827、911、徐华线、地铁10号线伊犁路站下1号口出；</div>
        <div class="sj">电话：62758027；</div>
        <div class="sj mt30">第三采集室：闵行七宝献血屋；</div>
        <div class="sj">时间：全年开放，每天9：00～20：00；</div>
        <div class="sj">地点：七莘路新龙路口（紧邻七莘路3155号乐购门口）；</div>
        <div class="sj">交通：87、91、92、92B、748、735、803、911、953、莘北线、莘纪线、松龙线；</div>
        <div class="sj">电话：64199263；</div>
        <div class="sj mt30">第四采集室：闵行梅陇（南方商城）献血屋；</div>
        <div class="sj">时间：全年开放，每天9：00～20：00；</div>
        <div class="sj">地点：沪闵路7388号莲花路口南方商城门前广场上；</div>
        <div class="sj">交通：1号线莲花路站、122、150、152、704、704B、712、720、729、732、732B、753、757、867；</div>
        <div class="sj">电话：54177866；</div>
        <div class="sj mt30">第五采集室：虹口鲁迅公园献血屋；</div>
        <div class="sj">时间：全年开放，每天9：00～20：00；</div>
        <div class="sj">地点：四川北路2388号（鲁迅公园正门右手侧）；</div>
        <div class="sj">交通：18、21、47、139、231、854、863、939、轻轨3号线虹口足球场站下；</div>
        <div class="sj">电话：56967708；</div>
        <div class="sj">第六采集室：普陀曹杨献血屋；</div>
        <div class="sj">时间：全年开放，每天9：00～17：00；</div>
        <div class="sj">地点：兰溪路164号（普陀区中心医院旁）；</div>
        <div class="sj">交通：公交01、44、63、94、129、136、223、551、706、708、807、858、860、948、950；</div>
        <div class="sj">电话：62166097</div>
   
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  font-size: 14px;

  background-image: url("../../assets/cjd/bg.png");
  background-size: cover;
  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;

    padding: 25px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>